import React from "react";
import "./Css/ContactSection.css";
import { MapPin, Phone, Clock, Mail } from "lucide-react";

const ContactSection = () => {
  return (
    <section className="contact-sections">
      <h2 className="contact-title">संपर्क साधा</h2>
      <p className="contact-subtitle">
        आमच्याशी संपर्क करण्याचे विविध मार्ग
      </p>

      <div className="contact-container">
        <div className="contact-card">
          <div className="icon-box location">
            <MapPin size={36} />
          </div>
          <h3>कार्यालयाचा पत्ता</h3>
          <p>तासगांव, सातारा</p>
          <p>महाराष्ट्र - ४१५००४</p>
        </div>

        <div className="contact-card">
          <div className="icon-box phone">
            <Phone size={36} />
          </div>
          <h3>फोन क्रमांक</h3>
          <p>+91 9172554563</p>
        </div>

        <div className="contact-card">
          <div className="icon-box clock">
            <Clock size={36} />
          </div>
          <h3>कार्यालयीन वेळा</h3>
          <p>सोम - शुक्र</p>
        
        </div>

        <div className="contact-card">
          <div className="icon-box email">
            <Mail size={36} />
          </div>
          <h3>ईमेल पत्ता</h3>
          <p>grap.tasgaon@gmail.com</p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
